{
  "version": 1,
  "asset_id": "9081d5e8-e031-405e-bea3-785a6d9101b0",
  "project_id": "ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe",
  "url": "/__l5e/assets-v1/9081d5e8-e031-405e-bea3-785a6d9101b0/datalignadvisory-240.webp",
  "r2_key": "a/v1/ffb64923-1b9a-4ca5-abb2-d5d5fcd875fe/9081d5e8-e031-405e-bea3-785a6d9101b0/datalignadvisory-240.webp",
  "original_filename": "datalignadvisory-240.webp",
  "size": 6172,
  "content_type": "image/webp",
  "created_at": "2026-09-21T21:10:22Z"
}
